import { render, staticRenderFns } from "./MaterialScrapDialog.vue?vue&type=template&id=7bc111ba&"
import script from "./MaterialScrapDialog.vue?vue&type=script&lang=js&"
export * from "./MaterialScrapDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports